import { Component } from '@angular/core';

@Component({
  selector: 'app-windows',
  template: `
    <div class="center">
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1282_1903)">
          <path d="M2 5.125V11.375H10.75V4.03125L2 5.125Z" fill="currentColor"/>
          <path d="M12 3.875V11.375H22V2.625L12 3.875Z" fill="currentColor"/>
          <path d="M12 12.625V20.125L22 21.375V12.625H12Z" fill="currentColor"/>
          <path d="M2 12.625V18.875L10.75 19.9688V12.625H2Z" fill="currentColor"/>
        </g>
        <defs>
          <clipPath id="clip0_1282_1903">
            <rect width="20" height="20" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    </div>
  `,
  styleUrls: ['./center.style.css'],
})
export class WindowsComponent { } 